import React from "react";

const Contect = () => {
  return (
    <>
      {/* Section contact Start */}
      <section class="contact">
        <div class="container" data-aos="fade-up">
          <header class="section-header">
            <h1 className="py-3 text-center" style={{ color: "#e25111" }}>
              Contact Us
            </h1>
          </header>

          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="row gy-4">
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-geo-alt" style={{ color: "#e25111" }}></i>
                    <h3 style={{ color: "#e25111" }}>Address</h3>
                    <p>
                      Modal Town :
                      <br />M Block 483 Punjab Pakistan
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-telephone" style={{ color: "#e25111" }}></i>
                    <h3 style={{ color: "#e25111" }}>Call Us</h3>
                    <p>
                      +92 323 4240630
                      <br />
                      +92 301 8476693
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-envelope" style={{ color: "#e25111" }}></i>
                    <h3 style={{ color: "#e25111" }}>Email Us</h3>
                    <p>
                      info@example.com
                      <br />
                      contact@example.com
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-box">
                    <i class="bi bi-clock" style={{ color: "#e25111" }}></i>
                    <h3 style={{ color: "#e25111" }}>Open Hours</h3>
                    <p>
                      Monday - Friday
                      <br />
                      9:00AM - 05:00PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <form action=" " method=" " class="php-email-form">
                <div class="row gy-4">
                  <div class="col-md-6">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div class="col-md-6">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>

                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      name="subject"
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div class="col-md-12">
                    <textarea
                      class="form-control"
                      name="message"
                      rows="6"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>

                  <div class="col-md-12 text-center">
                    <div class="loading">Loading</div>
                    <div class="error-message"></div>
                    <div class="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button className="btn-now">SUBMIT</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Section contact End */}
    </>
  );
};

export default Contect;
